// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"515":"590845b05481e29b","651":"5e17db1283821a2e","741":"b0f2690809a0a353"}[chunkId] + ".js";
};